import {Links, MappedImage} from "../../utils/fw"

import {UseHeartbeats} from "./HookWrappers"


export const Room = room => {
	const [{
		"First & Last Name": name,
		"Registrant ID": userID,
		"Event Name": eventID,
		"Registrant Type": regType,
	}] = window.dataLayer

	return <div style="position: relative" {...room}>
		<UseHeartbeats
			page={room.name}
			data={{
				eventID,
				name,
				userID,
				regType,
			}}
		/>
		<MappedImage imageURL={room.background} imageFunction={room.backgroundFunction}>
			<Links links={room.links} roomName={room.name} />
		</MappedImage>
		{room.extras}
	</div>
}
